export default class AppRoutes {
	public static readonly Root = '/studio';
	public static readonly Login = '/studio/login';
	public static readonly TermsAndConditions = '/studio/terms-and-conditions';
	public static readonly PrivacyPolicy = '/studio/privacy-policy';
	public static readonly Dashboard = '/studio/dashboard';
	public static readonly ForgotPassword = '/studio/forgot-password';
	public static readonly CreateFlowWizard = '/studio/create-flow-wizard';
	public static CreateFlowWizardWithContext(clientSpaceID?: string, projectSpaceID?: string) {
		return `${AppRoutes.CreateFlowWizard}/${clientSpaceID ?? ':clientSpaceID'}/${projectSpaceID ?? ':projectSpaceID'}`;
	}
	public static readonly Settings = '/studio/settings';
	public static readonly SignUp = '/studio/sign-up';
	/** Studio-hosted OAuth popup landing page - relays the Xero OAuth result to the opener via postMessage. */
	public static readonly XeroOAuthCallback = '/studio/xero-oauth-callback';
	/** Studio-hosted OAuth popup landing page - relays the HubSpot OAuth result to the opener via postMessage. */
	public static readonly HubSpotOAuthCallback = '/studio/hubspot-oauth-callback';
	public static readonly FlowList = '/studio/flow-list';
	public static readonly Triggers = '/studio/triggers';
	public static TriggerEditView(flowId?: string, taskId?: string) {
		return `${AppRoutes.Triggers}/edit/${flowId ?? ':flowId'}/${taskId ?? ':taskId'}`;
	}
	public static FlowView(flowId?: string, isEditView?: boolean) {
		return `/studio/flow-list/flow/${flowId ?? ':flowId'}${isEditView ? '?isEdit=true' : ''}`;
	}
	public static readonly ClientSpaceListRoute = '/studio/client-space-list';
	public static ClientSpaceRoute(clientSpaceID?: string) {
		return `/studio/client-space-list/${clientSpaceID ?? ':clientSpaceID'}`;
	}
	public static ProjectSpace(clientSpaceID?: string, projectSpaceID?: string) {
		return `${AppRoutes.ClientSpaceRoute(clientSpaceID)}/project-space/${projectSpaceID ?? ':projectSpaceID'}`;
	}

	public static ImportIntegration(clientSpaceID?: string, projectSpaceID?: string) {
		return `${AppRoutes.ClientSpaceRoute(clientSpaceID)}/project-space/${projectSpaceID ?? ':projectSpaceID'}/integration-import`;
	}

	public static IntegrationSpace(
		clientSpaceID?: string,
		projectSpaceID?: string,
		flowId?: string,
		isEditView?: boolean
	) {
		return `${AppRoutes.ProjectSpace(clientSpaceID, projectSpaceID)}/integration-space/${flowId ?? ':flowId'}${isEditView ? '?isEdit=true' : ''}`;
	}
	public static UserManagement() {
		return '/studio/user-management';
	}
	public static TenantManagement() {
		return '/studio/tenant-management';
	}
	public static RoleManagement() {
		return '/studio/role-management';
	}
	public static Unauthorized() {
		return '/studio/unauthorized';
	}
	public static AccessRequests() {
		return '/studio/access-requests';
	}
	static IpWhitelistManagement(): string {
		return '/studio/ip-whitelist-management';
	}
	static IpWhitelistEdit(whitelistIpId?: string): string {
		return `/studio/ip-whitelist-management/edit/${whitelistIpId ?? ':whitelistIpId'}`;
	}
	static ApiKeyManagement(): string {
		return '/studio/api-key-management';
	}
	static ApiKeyEdit(apiKeyID?: string): string {
		return `/studio/api-key-management/edit/${apiKeyID ?? ':apiKeyID'}`;
	}
	static SecretsManagement(): string {
		return '/studio/secrets-management';
	}
	static SecretEdit(secretID?: string): string {
		return `/studio/secrets-management/edit/${secretID ?? ':secretID'}`;
	}
	static ProfileDashboard(): string {
		return '/studio/profile-dashboard';
	}
	static MfaScreen(): string {
		return '/studio/mfa';
	}
}
